import React from 'react';
import { usePhoneTheme } from '../../../../ForBrands/useIsPhone';
import { AutosaveBar } from '../../../../ForBrands/ui/mobile/MobileUI';
import { FormField, Grid2, HubCard, HubInput, SaveStatus } from '../../../../ForAthletes/v2/edit/editHubPieces';
import { KeyValueCard, KeyValueRow, SectionFooter, SectionHead, SupportLink } from '../coachProfilePieces';

const ToChange = () => (
  <>
    <SupportLink /> to change.
  </>
);

// Figma 01 · Account information. Names save as you go; email and role are
// the account's and only support changes them.
//
// Phones (2471:3878): no card, first and last name side by side, the email
// without its hint, the role in its own card with the support note under
// it, and the AutosaveBar (save status and Done) instead of Save / Next.
// `onDone` and `doneBusy` drive that Done.
const AccountSection = ({ account, form, next, onNext, onDone, doneBusy = false }) => {
  const phone = usePhoneTheme();
  const { form: values, edit, save, status, error, fieldErrors } = form;
  const firstName = (
    <FormField label="First name" error={fieldErrors.firstName}>
      <HubInput aria-label="First name" autoComplete="given-name" value={values.firstName} onChange={(e) => edit({ firstName: e.target.value })} />
    </FormField>
  );
  const lastName = (
    <FormField label="Last name" error={fieldErrors.lastName}>
      <HubInput aria-label="Last name" autoComplete="family-name" value={values.lastName} onChange={(e) => edit({ lastName: e.target.value })} />
    </FormField>
  );

  if (phone) {
    return (
      <>
        <div className="grid grid-cols-2 gap-3">
          {firstName}
          {lastName}
        </div>
        <FormField label="Email">
          <HubInput aria-label="Email" value={account.email} readOnly aria-readonly="true" />
        </FormField>
        <KeyValueCard>
          <KeyValueRow label="Role">{account.role}</KeyValueRow>
        </KeyValueCard>
        <p className="bm-body-s text-bm-tertiary">
          <ToChange />
        </p>
        <AutosaveBar status={status} error={error} onDone={onDone} busy={doneBusy} />
      </>
    );
  }

  return (
    <>
      <SectionHead title="Account information" right={<SaveStatus status={status} error={error} />} />
      <HubCard>
        <Grid2>
          {firstName}
          {lastName}
        </Grid2>
        <FormField label="Email" hint={<ToChange />}>
          <HubInput aria-label="Email" value={account.email} readOnly aria-readonly="true" />
        </FormField>
        <div className="flex flex-col gap-[2px]">
          <KeyValueRow label="Role">{account.role}</KeyValueRow>
          <p className="bm-body-s text-bm-tertiary">
            <ToChange />
          </p>
        </div>
      </HubCard>
      <SectionFooter onSave={save} saving={status === 'saving'} next={next} onNext={onNext} />
    </>
  );
};

export default AccountSection;
